<template>
  <div id='app'>
    <router-view></router-view>
  </div>
</template>

<script>
import EventBus from '@/event/event-bus'

export default {
  name: 'App',

  instance: null,

  created() {},

  updated() {},

  methods: {
    unloadLogout(e) {
      this.$store.dispatch('LogOut')
      return e
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        EventBus.$emit('closeSocket')
        this.$store.dispatch('ResetRouters').then(() => {
          this.$router.replace({ name: 'Login', query: { timeout: 1 }})
        })
      })
    }
  }
}
</script>

<style lang='scss'>
.grecaptcha-badge {
  visibility: hidden;
}

.el-button--primary {
  color: #fff;
  background-color: #0972ce;
  border-color: #0972ce;
}
</style>



// WEBPACK FOOTER //
// src/App.vue